export default {"src":"/_next/static/media/op-design.ddc4cac2.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};